export const DEVICE_TYPE_IS = {
    MOBILE : 'DEVICE_IS_MOBILE',
    TABLET : 'DEVICE_IS_TABLET',
    DESKTOP : 'DEVICE_IS_DESKTOP',
};